import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { apiRequest } from '../api/index';
import DefaultLayout from "../components/DefaultLayout";
import MyLeadsContent from '../components/MyLeads/MyLeadsContent';
import MobileDefaultLayout from "../components/MobileDefaultLayout";

const Leads = () => {
  const { id } = useParams();
  const [userID, setUserID] = useState(null);
  const [packages, setPackages] = useState([]);
  const [packageTypes, setPackageTypes] = useState([]);
  const [flowTypes, setFlowTypes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Загрузка данных при монтировании компонента
  useEffect(() => {
    let isMounted = true;

    const loadData = async () => {
      try {
        setLoading(true);


        if (!isMounted) return;

        setUserID(id);

        // Загружаем пакеты
        const loadedPackagesResponse = await apiRequest(`pakets?rekl_id=${id}`, 'GET');
        const loadedPackages = loadedPackagesResponse.data?.pakets || [];

        if (!isMounted) return;

        setPackages(loadedPackages);

        // Загружаем типы пакетов
        const loadedPackageTypesResponse = await apiRequest('paks', 'GET');
        const loadedPackageTypes = loadedPackageTypesResponse.data || [];

        if (!isMounted) return;

        setPackageTypes(loadedPackageTypes);

        // Загружаем типы потоков
        const loadedFlowTypesResponse = await apiRequest('flow-guides', 'GET');
        const loadedFlowTypes = loadedFlowTypesResponse.data || [];

        if (isMounted) {
          setFlowTypes(loadedFlowTypes);
          setError(null);
        }
      } catch (err) {
        if (isMounted) {
          setError('Не удалось загрузить данные');
          console.error('Ошибка загрузки данных:', err);
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    loadData();

    return () => {
      isMounted = false;
    };
  }, []);

  if (loading) {
    return (
      <MobileDefaultLayout>
        <div className="myleads-container">
          <div className="leads-table-container">
            <div className="loading">Загрузка...</div>
          </div>
        </div>
      </MobileDefaultLayout>
    );
  }

  if (error) {
    return (
        <MobileDefaultLayout>
          <div className="myleads-container">
            <div className="error">{error}</div>
          </div>
        </MobileDefaultLayout>
    );
  }

  return (
      <MobileDefaultLayout>
        <MyLeadsContent
          userID={userID}
          packages={packages}
          packageTypes={packageTypes}
          flowTypes={flowTypes}
        />
      </MobileDefaultLayout>
  );
};

export default Leads;
